export function getUIContext({
  contextKey,
  column,
  labelContext,
  labelDetailsContext
}: {
  contextKey?: string;
  column?: string;
  labelContext?: string;
  labelDetailsContext?: string;
} = {}): URLSearchParams {
  const url = new URLSearchParams();
  url.append("modeDebug", sessionStorage.getItem("modeDebug") || "false");
  url.append("adminLevel", sessionStorage.getItem("adminLevel") || "0");
  url.append("colOrigine", column || "");

  labelContext && url.append("labelContext", labelContext);
  labelDetailsContext && url.append("labelDetailsContext", labelDetailsContext);
  contextKey && url.append("contextKey", contextKey);

  return url;
}
